import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/stories`;

export const addStories = (stories) => {
  return axios.post(`${url}`, stories);
};



// WEBPACK FOOTER //
// ./src/views/pages/stories/requests/addStories.js